import Dexie, { type Table } from "dexie";
import type { ChessGameCollection } from "../models/chess-game-collection";
import type { ChessGame } from "../models/chess-game-model";
import type { ChessStats } from "../models/stats/stats-model";
import type { User } from "../models/user-model";

export const DATABASE_NAME = "chess-db";

export class ChessDB extends Dexie {
    user!: Table<User, string>;
    games!: Table<ChessGame, string>;
    collections!: Table<ChessGameCollection, string>;
    collectionStats!: Table<ChessStats, string>;

    constructor() {
        super(DATABASE_NAME);
        this.version(1).stores({
            user: "id",
            games: "id,collectionId,slug",
            collections: "id,username,source",
        });
        this.version(2).stores({
            collectionStats: "collectionId",
        });
    }
}

export const db = new ChessDB();

export const clearDatabase = async () => {
    await db.delete();
    await db.open();
};
